import React, { Component } from 'react';
import './App.css';
import BuyNow from "./BuyNow";
import Grid from '@material-ui/core/Grid';

class Product1 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFlushed: false
		};
	}

    componentDidMount() {
        if (window.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
                this.ShopifyBuyInit();
            }
            else {
                this.loadScript();
            }
        }
        else {
            this.loadScript();
        }
    }

    loadScript() {
        var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
        var script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = this.ShopifyBuyInit;
    }

    ShopifyBuyInit() {
        var client = window.ShopifyBuy.buildClient({
            domain: 'newfangle-llc.myshopify.com',
            storefrontAccessToken: 'a756723c50787179031f4335cd6feda4',
        });

        window.ShopifyBuy.UI.onReady(client).then(function (ui) {
			/* The Ingenue - Hardback */
            ui.createComponent('product', {
                id: '7387601305797',
                node: document.getElementById('product-component-ingenue-hardback'),
                moneyFormat: '%24%7B%7Bamount%7D%7D',
                options: {
                    "product": {
                        "styles": {
                            "product": {
                                "@media (min-width: 601px)": {
                                    "max-width": "calc(25% - 20px)",
                                    "margin-left": "20px",
                                    "margin-bottom": "50px"
                                }
                            }
                        },
                        "buttonDestination": "modal",
                        "contents": {
                            "options": false,
							"price": false
                        },
                        "text": {
                            "button": "View product"
                        }
                    },
                    "productSet": {
                        "styles": {
                            "products": {
                                "@media (min-width: 601px)": {
                                    "margin-left": "-20px"
                                }
                            }
                        }
                    },
                    "modalProduct": {
                        "contents": {
                            "img": false,
                            "imgWithCarousel": true,
                            "button": false,
                            "buttonWithQuantity": true
                        },
                        "styles": {
                            "product": {
                                "@media (min-width: 601px)": {
                                    "max-width": "100%",
                                    "margin-left": "0px",
                                    "margin-bottom": "0px"
                                }
                            }
                        },
                        "text": {
                            "button": "Add to cart"
                        }
                    },
                    "cart": {
                        "text": {
                            "total": "Subtotal",
                            "button": "Checkout"
                        }
                    }
                },
            });

			/* The Ingenue - Paperback v2 */
            ui.createComponent('product', {
                id: '7387713732805',
                node: document.getElementById('product-component-ingenue-v2'),
                moneyFormat: '%24%7B%7Bamount%7D%7D',
                options: {
                    "product": {
                        "styles": {
                            "product": {
                                "@media (min-width: 601px)": {
                                    "max-width": "calc(25% - 20px)",
                                    "margin-left": "20px",
                                    "margin-bottom": "50px"
                                }
                            }
                        },
                        "buttonDestination": "modal",
                        "contents": {
                            "options": false,
							"price": false
                        },
                        "text": {
                            "button": "View product"
                        }
                    },
                    "productSet": {
                        "styles": {
                            "products": {
                                "@media (min-width: 601px)": {
                                    "margin-left": "-20px"
                                }
                            }
                        }
                    },
                    "modalProduct": {
                        "contents": {
                            "img": false,
                            "imgWithCarousel": true,
                            "button": false,
                            "buttonWithQuantity": true
                        },
                        "styles": {
                            "product": {
                                "@media (min-width: 601px)": {
                                    "max-width": "100%",
                                    "margin-left": "0px",
                                    "margin-bottom": "0px"
                                }
                            }
                        },
                        "text": {
                            "button": "Add to cart"
                        }
                    },
                    "cart": {
                        "text": {
                            "total": "Subtotal",
                            "button": "Checkout"
                        }
                    }
                },
            });
        });
    }

    scriptLoaded() {
    }

    render() {
    	return (
			<div style={{ marginBottom: "100px" }}>
			<Grid container direction="row" justify="center" alignItems="flex-end">
				<Grid item xs="12" sm="6" md="4" lg="3">
					<div id='product-component-ingenue-v2' style={{ paddingBottom: '12px' }}/>
				</Grid>
				<Grid item xs="12" sm="6" md="4" lg="3">
					<div id='product-component-ingenue-hardback' style={{ paddingBottom: '12px' }}/>
				</Grid>
				<Grid item xs="12" sm="6" md="4" lg="3">
					<BuyNow
						productTitle="The Ingénue (Kindle Edition)"
						disabled={false}
						buttonTitle="View product"
						buttonLink="https://www.amazon.com/gp/r.html?C=2Z24ENUUAEWUK&K=3AIIK8M6AH4S9&M=urn:rtn:msg:202010230347527607674f04834c2c93a2f9494730p0na&R=HR8XCNWZMRAQ&T=C&U=http%3A%2F%2Fwww.amazon.com%2Fdp%2FB08LP653NR%3Fref_%3Dpe_3052080_276849420&H=AWK8AIUCNMAPPWF9OGQPD08LMUIA&ref_=pe_3052080_276849420"
						imageSrc="https://cdn.shopify.com/s/files/1/0504/8706/6821/products/3d-kindle-cover_550x825.jpg?v=1603375808"
					/>
				</Grid>
				<Grid item xs="12" sm="6" md="4" lg="3">
					<BuyNow
						productTitle="The Ingénue (Audiobook)"
						disabled={false}
						buttonTitle="View product"
						buttonLink="https://www.audible.com/pd/B09N4QZH3W"
						imageSrc="https://cdn.shopify.com/s/files/1/0504/8706/6821/products/61af6d2ade907d00171e376f-c9e7545649424a6-2021-12-0714_19_15.225221.png?v=1638886874"
					/>
				</Grid>
			</Grid>
			</div>
    	);
    }
}

/*const mapStateToProps = (state, ownProps) => {
	return {
		active: ownProps.blogs === state.blogs
	}
}

export default connect(mapStateToProps)(Shop);*/

export default Product1;
